// @flow
import React, { PureComponent, type ComponentType } from "react";
import { getDisplayName } from "data/constants";
import loc from "i18next";

type Props = {
    /** callback when value has been changed
     * @param {string} name field's name
     * @param {any} value new field's value
     */
    onChange: (name: string, value: any) => void,
    /** current value */
    value: ?Array<any>,
};

type State = {
    value1: ?any,
    value2: ?any,
};

/** wraps *EditorControls to allow FromTo operator */
const toBetweenEditor = (
    WrappedComponent1: ComponentType<any>,
    WrappedComponent2: ComponentType<any>,
    withRequiredValidation: boolean = false
) =>
    class PP extends PureComponent<Props, State> {
        upstreamOnChange: (name: string, value: any) => void;
        // opRef: ElementRef<*>;

        static displayName = `toBetweenEditor(${getDisplayName(
            WrappedComponent1
        )},${getDisplayName(WrappedComponent2)})`;

        constructor(props: Props) {
            super(props);
            this.state = {
                value1: Array.isArray(props.value) ? props.value[0] : null,
                value2: Array.isArray(props.value) ? props.value[1] : null,
                isValid1: true,
                isValid2: true,
            };
            this.upstreamOnChange = this.props.onChange;
        }

        componentDidUpdate(prevProps) {
            const newState = {};
            if (prevProps.value?.[0] !== this.props.value?.[0]) {
                newState.value1 = this.props.value?.[0];
            }
            if (prevProps.value?.[1] !== this.props.value?.[1]) {
                newState.value2 = this.props.value?.[1];
            }
            if (Object.keys(newState).length) {
                this.setState(newState);
            }
        }

        _onChange = () => {
            this.upstreamOnChange(this.props.name, [
                this.state.value1,
                this.state.value2,
            ]);
        };

        _onChangeValue1 = (name: string, value1: any) =>
            this.setState({ value1 }, this._onChange);

        _onChangeValue2 = (name: string, value2: any) =>
            this.setState({ value2 }, this._onChange);

        _onValidationChange1 = (name: string, isValid1: any) =>
            this.setState({ isValid1 });

        _onValidationChange2 = (name: string, isValid2: any) =>
            this.setState({ isValid2 });

        render = () => (
            <WrappedComponent1
                {...this.props}
                value={this.state.value1}
                name={`${this.props.name}[0]`}
                overrideIsValid={this.state.isValid1 && this.state.isValid2}
                onValidationChange={this._onValidationChange1}
                onChange={this._onChangeValue1}
                placeholder={loc.t("search:form.input.placeholderFrom")}
                required={
                    this.props.isRequired ||
                    (withRequiredValidation && !!this.state.value2)
                }
                additionalRender={
                    <WrappedComponent2
                        {...this.props}
                        value={this.state.value2}
                        name={`${this.props.name}[1]`}
                        overrideIsValid={
                            this.state.isValid1 && this.state.isValid2
                        }
                        onValidationChange={this._onValidationChange2}
                        isAdditionalRender={true}
                        onChange={this._onChangeValue2}
                        placeholder={loc.t("search:form.input.placeholderTo")}
                        autoFocus={false}
                        required={
                            this.props.isRequired ||
                            (withRequiredValidation && !!this.state.value1)
                        }
                    />
                }
            />
        );
    };

export default toBetweenEditor;
